var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-select',{attrs:{"label":_vm.label,"value":_vm.value,"fancy":_vm.fancy,"items":_vm.items},on:{"input":function($event){return _vm.setValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }